import { ContactOverviewItem } from '@futrli-sdk/predict';

import { penceToAmount } from '../../../../core/formatters';
import { getDateWithStartOfDay } from '../../../../utils/dates';
import { CASFilters, TransformedContact } from './types';

const PERCENTAGE_MULTIPLIER = 100;

/**
 * Transforms raw API data into the format needed for the UI, including date parsing and currency formatting
 * @param raw - The raw contact data from the API
 * @returns An array of transformed contact data suitable for the UI
 */
export const transformContactData = (raw: ContactOverviewItem[]): TransformedContact[] =>
  raw.map(item => ({
    ...item,
    last_activity: getDateWithStartOfDay(new Date(item.last_activity)),
    dependence: Math.round(item.dependence * PERCENTAGE_MULTIPLIER),
    total_amount_due: penceToAmount(item.total_amount_due),
    total_amount_overdue: penceToAmount(item.total_amount_overdue),
    total_amount_invoiced: penceToAmount(item.total_amount_invoiced),
    average_sale: penceToAmount(item.average_sale)
  }));

/**
 * Deserializes date strings in the filters into Date objects
 * @param filters - The filters with date strings
 * @returns The filters with Date objects
 */
export const deserializeDates = (filters: CASFilters): CASFilters => ({
  ...filters,
  lastActivity: {
    from: filters.lastActivity.from ? new Date(filters.lastActivity.from) : undefined,
    to: filters.lastActivity.to ? new Date(filters.lastActivity.to) : undefined
  }
});

const MONTH_OFFSET = 1;
const PAD_LENGTH = 2;

/**
 * Formats a Date object into a string format suitable for date inputs (e.g., "DD/MM/YYYY")
 * @param date - The Date object to format
 * @returns A string representing the formatted date
 */
export const formatDateForInput = (date: Date): string => {
  const d = date.getDate().toString().padStart(PAD_LENGTH, '0');
  const m = (date.getMonth() + MONTH_OFFSET).toString().padStart(PAD_LENGTH, '0');
  const y = date.getFullYear();
  return `${d}/${m}/${y}`;
};
